import React from 'react';
import "./../App.css";
import { Card, CardDeck, Modal, Button, InputGroup, FormControl, Form, Col } from 'react-bootstrap';
//import { AirlineSeatReclineExtraOutlined } from '@material-ui/icons';
import Scanner from "./Scanner";


class ReceiveLicensePlate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {    
            lp: null,
            po: null,
            wmsempactivityreport: undefined,
            purchaseorder: null,
            showScanner: false,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.goBack = this.goBack.bind(this);
        this.onNewScanResult = this.onNewScanResult.bind(this);  
        this.scan = this.scan.bind(this);    
        this.closeScanner = this.closeScanner.bind(this);
    }
    componentDidMount() { 
        if (this.props.location.state && this.props.location.state.purchaseorder) {
            this.state.wmsempactivityreport = this.props.location.state.wmsempactivityreport;
            this.setState({po: this.props.location.state.po, purchaseorder: this.props.location.state.purchaseorder});
        }
    }

    handleInputChange = (event) => {    
        const target = event.target;
        const name = target.id;   
        this.setState({
          [name]: target.value
        });   
      }

    handleSubmit(e) {
        var { from } = { from: { pathname: "/receiveitms" } };  
        this.props.history.push(from, this.state);    
    }
    
    goBack =() => {
        this.props.history.goBack();
    }

    scan =() => {
        console.log('Scan is called');
      }

    render() {
        if (!this.state.po) {
            return <div></div>;
        }
        //console.log('LP', this.state);
        return (
            
            <div>                
                <Card>
                    <Card.Header>Receiving Goods                        
                    </Card.Header>
                    <Card.Body>
                      <Form onSubmit={this.handleSubmit}>
                        <Form.Row>
                        <Form.Label style={{fontSize: "14px", fontWeight: 'bold'}}>&nbsp;Purchase Order: {this.state.purchaseorder}</Form.Label>

                        </Form.Row>
                        <Form.Row>
                        <Form.Label style={{fontSize: "14px", fontWeight: 'bold'}}>&nbsp;Vendor: {this.state.po.clientName}</Form.Label>

                        </Form.Row>
                        
                        <Form.Row>
                            <Form.Group as={Col} controlId="lp" 
                                onChange={this.handleInputChange}>
                            <Form.Label style={{fontSize: "14px"}}>License Plate or Pallet</Form.Label>
                            <InputGroup className="mb-3">
                                <Form.Control required={true} placeholder="Scan or enter license plate" defaultValue={this.state.lp} autoFocus />                                
                                <Button variant="outline-secondary" id="button-addon2" type="button" onClick={() => {this.scan()}}>
                                    Scan
                                </Button>
                            </InputGroup>                            
                            </Form.Group>
                        </Form.Row> 
                        <div style={{float: "left"}} >                                       
                        <Button variant="outline-primary mr-3" size="sm" type="submit">Next</Button>                              
                        <Button variant="outline-primary mr-3" size="sm" type="button" onClick={() => {this.scan()}}>Scan</Button>                              
                        <Button variant="outline-primary mr-3" size="sm" type="button" onClick={() => {this.goBack()}}>Cancel</Button>                              
                        </div>
                      </Form>
                      <Scanner showScanner={this.state.showScanner} closeScanner={this.closeScanner} onNewScanResult={this.onNewScanResult}></Scanner>
                    </Card.Body>
                </Card>
            </div>
            
        );
    }

    scan =() => {
        //console.log('Scan item is called');        
        this.setState({showScanner: true});
    }
    
    closeScanner() {
        this.setState({showScanner: false})
    }

    onNewScanResult(decodedText, decodedResult) {
        // Handle the result here.
        console.log('Scanned Result', decodedText, decodedResult);  
        this.setState({showScanner: false, lp: decodedText}); 
    } 
}
export default ReceiveLicensePlate;